var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 0.333374C5.55967 0.333374 0.333008 5.56004 0.333008 12C0.333008 18.44 5.55967 23.6667 11.9997 23.6667C18.4397 23.6667 23.6663 18.44 23.6663 12C23.6663 5.56004 18.4397 0.333374 11.9997 0.333374ZM11.9997 5.00004C14.2513 5.00004 16.083 6.83171 16.083 9.08337C16.083 11.335 14.2513 13.1667 11.9997 13.1667C9.74801 13.1667 7.91634 11.335 7.91634 9.08337C7.91634 6.83171 9.74801 5.00004 11.9997 5.00004ZM11.9997 21.3334C9.63134 21.3334 6.83134 20.3767 4.83634 17.9734C6.87988 16.37 9.40223 15.4986 11.9997 15.4986C14.5971 15.4986 17.1195 16.37 19.163 17.9734C17.168 20.3767 14.368 21.3334 11.9997 21.3334Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.a8c8781eb41dda6b2798a3f79c2d0dab.svg";
export { ForwardRef as ReactComponent };